import { render, staticRenderFns } from "./ReportI.vue?vue&type=template&id=1babfef4&scoped=true&"
import script from "./ReportI.vue?vue&type=script&lang=js&"
export * from "./ReportI.vue?vue&type=script&lang=js&"
import style0 from "./ReportI.vue?vue&type=style&index=0&id=1babfef4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1babfef4",
  null
  
)

export default component.exports